import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d42c5f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-info" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"icon\" data-v-d42c5f04><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-d42c5f04><circle cx=\"30\" cy=\"30\" r=\"25\" fill=\"#39B54A\" data-v-d42c5f04></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.6822 20.9171L26.6646 32.8953C26.3475 33.1655 25.8897 33.1875 25.5479 32.9484L20.9972 29.7583C20.6344 29.5037 20.141 29.5467 19.8276 29.8618L18.4304 31.2613C18.074 31.6185 18.074 32.1983 18.4304 32.5564L25.7362 39.8782C26.0925 40.2363 26.6719 40.2363 27.0292 39.8782L43.2628 23.6062C43.6201 23.249 43.6201 22.6692 43.2628 22.3111L41.9213 20.9665C41.5841 20.6286 41.045 20.6075 40.6822 20.9171Z\" fill=\"white\" data-v-d42c5f04></path></svg></div><div class=\"submited-title\" data-v-d42c5f04>保单已提交</div>", 2)
const _hoisted_4 = {
  key: 0,
  class: "submited-content"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "保单已完成创建，保险将于完成支付后的次日", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "生效，请及时完成支付。", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "submited-content"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "保单已完成创建，保险将于目前享受的增值服", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "务失效后的次日生效，请及时完成支付。", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "white-block nongfu-button-wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "方式一：前往浏览器粘贴链接", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy-tips" }, "请复制以下链接在浏览器打开并完成保单支付", -1))
const _hoisted_15 = { class: "copy-url" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "方式二：微信扫码支付", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy-tips" }, "截图保存二维码并打开微信扫一扫", -1))
const _hoisted_18 = { class: "qrcode-wrap" }

import { onMounted, onUnmounted, ref } from 'vue'
import { Button, Divider } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { commonErrorHandle } from '@/utils/error-handle'
import { getClientJijiaInsuranceDetail } from '@/apis/insurance'
import { showToastFail, showToastSuccess } from '@/utils/tools'
import { CachePinanOrderPayed } from '@/config/insurance'
import dayjs from 'dayjs'
import ClipboardJS from 'clipboard'
import AppHeader from '@/components/Header.vue'
import Qrcode from '@chenfengyuan/vue-qrcode'


export default /*#__PURE__*/_defineComponent({
  __name: 'after-submit',
  setup(__props) {

// 保单提交后的页面, 小程序专用
const $route = useRoute()
const $router = useRouter()
const paylink = decodeURIComponent($route.query.paylink as string)
const eq_sn = encodeURIComponent($route.query.eq_sn as string)
const effect_time = decodeURIComponent($route.query.effect_time as string)
const created_at = decodeURIComponent($route.query.created_at as string)
const effectiveTheNextDay = ref(false)
let timeId = 0
function dealySearch() {
  timeId = setTimeout(() => {
    loopSearch()
  }, 5000)
}
async function loopSearch() {
  // 轮询检测是否支付完成
  try {
    const data = await getClientJijiaInsuranceDetail({ eq_sn })
    if (data.status === 1) {
      // 待支付的时候
      dealySearch()
    } else if (data.status === 2) {
      // 支付成功的时候跳转详情页
      sessionStorage.setItem(CachePinanOrderPayed, '1')
      $router.replace({
        name: 'insurance-jijia-insurance-detail',
        query: {
          eq_sn: $route.query.eq_sn,
        },
      })
    } else {
      $router.replace({
        name: 'insurance-jijia-insurance-list',
      })
    }
  } catch (error) {
    console.log('error', error)
    // dealySearch()
    commonErrorHandle(error)
  }
}

onMounted(() => {
  const clipbordItem = new ClipboardJS('#copyItem', {
    text() {
      return paylink
    },
  })
  clipbordItem.on('success', function (e) {
    showToastSuccess('复制成功')
    e.clearSelection()
  })

  clipbordItem.on('error', function (e) {
    showToastFail('复制失败')
  })
  try {
    effectiveTheNextDay.value =
      dayjs(created_at).add(1, 'day').hour(0).minute(0).second(0).unix() ===
      dayjs(effect_time).unix()
  } catch (error) {
    console.log('error', error)
  }
  loopSearch()
})

onUnmounted(() => {
  clearTimeout(timeId)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "投保申请" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (effectiveTheNextDay.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11)),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(paylink)), 1),
        _createVNode(_unref(Button), {
          class: "copy-button",
          id: "copyItem"
        }, {
          default: _withCtx(() => [
            _createTextVNode("复制链接")
          ]),
          _: 1
        }),
        _createVNode(_unref(Divider), { class: "divider" }),
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(Qrcode), {
            value: _unref(paylink),
            options: {
            width: 120,
            margin: 1,
          }
          }, null, 8, ["value"])
        ])
      ])
    ])
  ], 64))
}
}

})